import { sanitizePlayerName } from '../ui/format';
import type { CompletedExtremeRun, ExtremeRunStateV1, ExtremeRunView } from './types';
import {
  EXTREME_BET_CENTS,
  EXTREME_PAID_SPINS,
  EXTREME_START_BALANCE_CENTS,
} from './types';

export function startExtremeRun(input: Readonly<{
  id: string;
  username: string;
  returnBalanceCents: number;
  returnBetCents: number;
  startedAt: number;
}>): ExtremeRunStateV1 {
  const username = sanitizePlayerName(input.username);
  if (!username) throw new RangeError('Ein Duellantenname wird benötigt.');
  return Object.freeze({
    version: 1,
    id: input.id,
    active: true,
    name: username,
    betCents: EXTREME_BET_CENTS,
    startBalanceCents: EXTREME_START_BALANCE_CENTS,
    returnBalanceCents: input.returnBalanceCents,
    returnBetCents: input.returnBetCents,
    startedAt: input.startedAt,
    paidSpinsCompleted: 0,
    featureCount: 0,
    baseSteps: Object.freeze([]),
    completedFeatures: Object.freeze([]),
  });
}

export function extremeRunView(run: ExtremeRunStateV1, balanceCents: number, bonusActive: boolean): ExtremeRunView {
  return Object.freeze({
    id: run.id,
    username: run.name,
    betCents: EXTREME_BET_CENTS,
    startBalanceCents: EXTREME_START_BALANCE_CENTS,
    startedAt: run.startedAt,
    paidSpinsCompleted: run.paidSpinsCompleted,
    paidSpinsRemaining: EXTREME_PAID_SPINS - run.paidSpinsCompleted,
    featureCount: run.featureCount,
    currentX: balanceCents / EXTREME_BET_CENTS,
    readyToComplete: run.paidSpinsCompleted === EXTREME_PAID_SPINS && !bonusActive,
  });
}

export function completeExtremeRun(
  run: ExtremeRunStateV1,
  finalBalanceCents: number,
  completedAt: number,
): CompletedExtremeRun {
  if (run.paidSpinsCompleted !== EXTREME_PAID_SPINS) {
    throw new Error(`Ein Extreme-Run kann erst nach ${EXTREME_PAID_SPINS} bezahlten Spins abgeschlossen werden.`);
  }
  return Object.freeze({
    id: run.id,
    username: run.name,
    betCents: EXTREME_BET_CENTS,
    startBalanceCents: EXTREME_START_BALANCE_CENTS,
    finalBalanceCents,
    startedAt: run.startedAt,
    completedAt,
    paidSpinsCompleted: EXTREME_PAID_SPINS,
    featureCount: run.featureCount,
    featureDrafts: run.completedFeatures,
  });
}
